import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/sdk';
import RectBtn from '@/components/Button/RectButton.vue';
import RoundBtn from '@/components/Button/RoundButton.vue';

Vue.component('rect-btn', RectBtn);
Vue.component('round-btn', RoundBtn);

Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();

if (process.env.NODE_ENV !== 'DEV') {
    Sentry.init({
        Vue,
        dsn: 'https://5f3bb3c5cb16419db8a29ce66f141253@o1115112.ingest.sentry.io/6146794',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
                tracingOrigins: ['localhost', process.env.VUE_APP_BASE_URL, /^\//],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}
new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount('#app');
